import { Link, useNavigate, useLocation } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentYear = new Date().getFullYear();
  const isAboutPage = location.pathname === '/about-us';

  return (
    <footer id="footer-root" className="bg-[#041B4A] text-slate-300 border-t-4 border-[#10B8B0]">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="xl:grid xl:grid-cols-4 xl:gap-8">
          
          {/* Brand block */}
          <div className="space-y-8 xl:col-span-1 pr-4 xl:pr-16 mb-12 xl:mb-0 animate-fade-in">
            <Link id="footer-logo" to="/" className="inline-block hover:opacity-90 transition-opacity mb-5">
              <img
                id="footer-logo-img"
                src="/assets/branding/finsahaj-logo.webp"
                alt="Finsahaj"
                className="block h-auto w-auto max-h-14 object-contain"
                width={220}
                height={56}
                loading="lazy"
                decoding="async"
                style={{
                  width: 'auto',
                  height: 'auto',
                  maxHeight: '56px',
                  objectFit: 'contain',
                }}
              />
            </Link>
          </div>

          {/* Quick links columns (4 columns display) */}
          <div className="mt-12 grid grid-cols-2 gap-8 xl:col-span-3 xl:mt-0 sm:grid-cols-2 md:grid-cols-4">
            
            {/* Column 1: Banking Services */}
            <div>
              <h3 className="text-xs font-bold uppercase tracking-wider text-slate-200 border-b border-[#10B8B0]/10 pb-2 font-sans">
                Banking Services
              </h3>
              <ul role="list" className="mt-4 space-y-2.5">
                <li>
                  <Link to="/search" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors font-sans">
                    IFSC Directory
                  </Link>
                </li>
                <li>
                  <Link to="/bank" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors font-sans">
                    Bank Directory
                  </Link>
                </li>
                <li>
                  <Link to="/state" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors font-sans">
                    State Directory
                  </Link>
                </li>
                <li>
                  <Link to="/city" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors font-sans">
                    City Directory
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 2: Financial Calculators */}
            <div>
              <h3 className="text-xs font-bold uppercase tracking-wider text-slate-200 border-b border-[#10B8B0]/10 pb-2 font-sans">
                Calculators
              </h3>
              <ul role="list" className="mt-4 space-y-2.5">
                <li>
                  <Link to="/calculators/emi" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors font-sans">
                    EMI Calculator
                  </Link>
                </li>
                <li>
                  <Link to="/calculators/sip" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors font-sans">
                    SIP Calculator
                  </Link>
                </li>
                <li>
                  <Link to="/calculators/fd" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors font-sans">
                    Fixed Deposit
                  </Link>
                </li>
                <li>
                  <Link to="/calculators/rd-calculator" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors font-sans">
                    Recurring Deposit
                  </Link>
                </li>
                <li>
                  <Link to="/calculators" className="text-sm font-semibold text-slate-350 hover:text-[#10B8B0] transition-colors font-sans">
                    All Calculators Suite
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 3: Educational Resources */}
            <div>
              <h3 className="text-xs font-bold uppercase tracking-wider text-slate-200 border-b border-[#10B8B0]/10 pb-2 font-sans">
                Educational Resources
              </h3>
              <ul role="list" className="mt-4 space-y-2.5 font-sans">
                <li>
                  <Link to="/guides/banking" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors">
                    Banking Basics
                  </Link>
                </li>
                <li>
                  <Link to="/guides/savings" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors">
                    Savings Guides
                  </Link>
                </li>
                <li>
                  <Link to="/guides/loans" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors">
                    Loan Guides
                  </Link>
                </li>
                <li>
                  <Link to="/guides/credit-cards" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors">
                    Credit Card Guides
                  </Link>
                </li>
                <li>
                  <Link to="/guides" className="text-sm font-semibold text-slate-350 hover:text-[#10B8B0] transition-colors">
                    All Guides Hub
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 4: Corporate & Trust */}
            <div>
              <h3 className="text-xs font-bold uppercase tracking-wider text-slate-200 border-b border-[#10B8B0]/10 pb-2 font-sans">
                Corporate & Trust
              </h3>
              <ul role="list" className="mt-4 space-y-2.5">
                <li>
                  <Link to="/about-us" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors font-sans">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/contact-us" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors font-sans">
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link to="/privacy-policy" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors font-sans">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors font-sans">
                    Terms & Conditions
                  </Link>
                </li>
                <li>
                  <Link to="/disclaimer" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors font-sans">
                    Disclaimer
                  </Link>
                </li>
                <li>
                  <Link to="/editorial-verification-policy" className="text-sm text-slate-300 hover:text-[#10B8B0] transition-colors font-sans">
                    Editorial & Verification
                  </Link>
                </li>
              </ul>
            </div>

          </div>
        </div>

        {/* Disclaimer & Bottom Bar */}
        <div className="mt-12 border-t border-slate-800/80 pt-8 sm:flex sm:items-center sm:justify-between">
          <p className="text-xs text-slate-450 leading-normal max-w-3xl font-sans text-slate-400">
            Disclaimer: Finsahaj is an independent banking guide. Please verify all branch and transfer details with your respective bank before initiating any transaction.
          </p>
          <div className="mt-6 sm:mt-0 text-left sm:text-right shrink-0 space-y-1">
            <p className="text-xs text-slate-400 font-sans">
              &copy; {currentYear} Finsahaj. All rights reserved.
            </p>
            <p className="text-[11px] text-slate-500 font-sans tracking-wide font-medium">
              Maintained by Roshan {isAboutPage ? (
                <span onClick={() => navigate('/admin', { state: { authorizedTrigger: true } })} className="select-text cursor-default">Brothers</span>
              ) : (
                <span>Brothers</span>
              )}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
